module.exports = __webpack_public_path__ + "img/ry_7.51aa59f0.png";